import styled from "styled-components";
import { GradientActionButton } from "./shell";

type ActiveProps = {
    active?: boolean;
};

type ToneProps = {
    background?: string;
    color?: string;
};

export const RightTabs = styled.div`
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    border-bottom: 1px solid var(--calendar-border);
    background: var(--calendar-shell);
`;

export const RightTab = styled.button<ActiveProps>`
    border: none;
    background: ${p => p.active ? "rgba(255,255,255,0.02)" : "transparent"};
    color: ${p => p.active ? "var(--calendar-accent)" : "var(--calendar-text-soft)"};
    padding: 0.9rem 0.4rem;
    font-size: 12px;
    font-weight: 700;
    cursor: pointer;
`;

export const RightPanelInner = styled.div`
    padding: 1rem;
    overflow-y: auto;
    display: grid;
    align-content: start;
    grid-auto-rows: max-content;
    gap: 1rem;
`;

export const TodoHeading = styled.div`
    font-weight: 800;
    font-size: 1rem;
`;

export const ProgressWrap = styled.div`
    display: grid;
    gap: 0.4rem;
`;

export const ProgressBar = styled.div`
    width: 100%;
    height: 6px;
    border-radius: var(--calendar-radius-badge);
    background: var(--calendar-surface-tertiary);
    overflow: hidden;
`;

export const ProgressFill = styled.div<{ percent: number }>`
    height: 100%;
    width: ${p => `${p.percent}%`};
    background: linear-gradient(90deg, var(--calendar-accent), #42e7b6);
    border-radius: inherit;
`;

export const AnalyticsButton = styled(GradientActionButton)<ActiveProps>``;

export const WeatherStrip = styled.div`
    display: grid;
    grid-template-columns: repeat(5, minmax(0, 1fr));
    gap: 0.5rem;
`;

export const WeatherCard = styled.div`
    background: var(--calendar-surface-secondary);
    border: 1px solid var(--calendar-border);
    border-radius: var(--calendar-radius-card);
    padding: 0.55rem 0.4rem;
    text-align: center;
`;

export const WeatherUnavailableCard = styled(WeatherCard)`
    grid-column: 1 / -1;
    text-align: left;
    padding: 0.75rem 0.85rem;
    display: grid;
    gap: 0.25rem;
`;

export const WeatherHeadline = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 0.75rem;
`;

export const TaskList = styled.div`
    display: grid;
    gap: 0.55rem;
`;

export const TaskCard = styled.div`
    display: grid;
    grid-template-columns: auto 1fr auto;
    gap: 0.6rem;
    align-items: start;
    background: var(--calendar-surface-secondary);
    border: 1px solid var(--calendar-border);
    border-radius: var(--calendar-radius-card);
    padding: 0.8rem;
`;

export const TaskCardIndicator = styled.div<ToneProps>`
    width: 18px;
    height: 18px;
    border-radius: var(--calendar-radius-cell);
    background: ${p => p.background || "var(--calendar-surface-tertiary)"};
    color: ${p => p.color || "var(--calendar-text-soft)"};
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 10px;
    font-weight: 800;
    margin-top: 0.15rem;
`;

export const TaskCheck = styled.button<{ checked?: boolean }>`
    width: 18px;
    height: 18px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: var(--calendar-radius-cell);
    border: 1px solid ${p => p.checked ? "#55d1a8" : "var(--calendar-border-strong)"};
    background: transparent;
    padding: 0;
    cursor: pointer;
    margin-top: 0.15rem;
`;

export const TaskCheckIcon = styled.img`
    width: 18px;
    height: 18px;
    display: block;
    pointer-events: none;
`;

export const TaskTitle = styled.div<{ done?: boolean }>`
    font-size: 13px;
    font-weight: 700;
    text-decoration: ${p => p.done ? "line-through" : "none"};
    opacity: ${p => p.done ? 0.7 : 1};
`;

export const TaskMeta = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 0.35rem;
    margin-top: 0.35rem;
`;

export const TaskTimeText = styled.span`
    color: var(--calendar-text-soft);
    font-size: 11px;
    font-weight: 600;
    padding: 0.1rem 0;
`;

export const FeatureCard = styled.div`
    display: flex;
    gap: 0.7rem;
    align-items: flex-start;
    border: 1px solid var(--calendar-border);
    background: var(--calendar-surface-secondary);
    border-radius: var(--calendar-radius-card);
    padding: 0.9rem;
`;

export const FeatureIcon = styled.div<{ color: string }>`
    width: 34px;
    height: 34px;
    border-radius: var(--calendar-radius-control);
    display: flex;
    align-items: center;
    justify-content: center;
    background: ${p => `${p.color}24`};
`;

export const TodayItem = styled.div`
    display: grid;
    grid-template-columns: 48px 1fr;
    gap: 0.75rem;
    padding: 0.9rem;
    border: 1px solid var(--calendar-border);
    background: var(--calendar-surface-secondary);
    border-radius: var(--calendar-radius-card);
`;

export const StatBox = styled.div`
    border: 1px solid var(--calendar-border);
    background: var(--calendar-surface-secondary);
    border-radius: var(--calendar-radius-card);
    padding: 0.85rem;
    display: grid;
    gap: 0.5rem;
`;
